import { createFileRoute, Link } from "@tanstack/react-router";
import { AiPromptButton } from "../components/AiPrompt";

export const Route = createFileRoute("/")({
  component: Home,
});

function Home() {
  return (
    <div className="screen">
      <header className="lh">
        <Link to="/" className="wordmark">
          notify<b>.</b>
        </Link>
        <nav className="lh-nav">
          <Link to="/docs" className="navlink">
            Docs
          </Link>
          <a
            href="https://github.com/mtkl6"
            target="_blank"
            rel="noreferrer"
          >
            GitHub
          </a>
          <Link to="/docs/quickstart" className="ghost">
            Get started
          </Link>
        </nav>
      </header>

      <main className="lander">
        <div>
          <span className="eyebrow">
            <span className="dot" />
            Early access — use at your own risk
          </span>
          <h1 className="headline">
            <span>Push</span>
            <span>in</span>
            <span className="hl">60s.</span>
          </h1>
          <p className="sub">
            Free to start. No account, no Firebase, no VAPID keys. Point one script tag at your users
            and send native browser notifications.
          </p>
          <div className="hero-ai">
            <AiPromptButton />
          </div>
          <div className="legal">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>

        <div className="steps">
          <div className="scard">
            <div className="scard-head">
              <span className="scard-num">1</span>
              <span className="scard-label">Add the script</span>
            </div>
            <pre className="scard-code">
              &lt;script src=<span className="s">"https://api.getnotify.dev/notify.js?token=ntfy_pk_…"</span>&gt;&lt;/script&gt;
            </pre>
          </div>

          <div className="scard">
            <div className="scard-head">
              <span className="scard-num">2</span>
              <span className="scard-label">Subscribe a user</span>
            </div>
            <pre className="scard-code">
              await notify.subscribe(user.id) <span className="c">// in the browser</span>
            </pre>
          </div>

          <div className="scard">
            <div className="scard-head">
              <span className="scard-num">3</span>
              <span className="scard-label">Send from your backend</span>
            </div>
            <pre className="scard-code">
              <span className="m">POST</span> api.getnotify.dev/send <span className="s">{`{ userId, body }`}</span> <span className="c">// with your secret key</span>
            </pre>
          </div>
        </div>
      </main>

      <footer className="lf">
        <div className="lf-badges">
          <a
            className="ph-badge"
            href="https://www.producthunt.com/products/notify-8?embed=true&utm_source=badge-featured&utm_medium=badge&utm_campaign=badge-notify-779e7268-6888-4e24-9e92-35959a3fa0a7"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              alt="notify - Browser notifications in 60 seconds | Product Hunt"
              width="250"
              height="54"
              loading="lazy"
              decoding="async"
              fetchPriority="low"
              src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=1177595&theme=dark"
            />
          </a>
          <a
            className="findly-badge"
            href="https://findly.tools/notify-browser-notifications-in-60-seconds?utm_source=notify-browser-notifications-in-60-seconds"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://findly.tools/badges/findly-tools-badge-dark.svg"
              alt="Featured on Findly.tools"
              width="175"
              height="55"
              loading="lazy"
              decoding="async"
              fetchPriority="low"
            />
          </a>
          <a
            className="twelve-badge"
            href="https://twelve.tools"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://twelve.tools/badge0-dark.svg"
              alt="Featured on Twelve Tools"
              width="200"
              height="54"
              loading="lazy"
              decoding="async"
              fetchPriority="low"
            />
          </a>
        </div>
        <div className="lf-links">
          <Link to="/docs">Docs</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <a href="https://github.com/mtkl6" target="_blank" rel="noreferrer">
            GitHub
          </a>
        </div>
      </footer>
    </div>
  );
}
